import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Modal from "../../../../../global/Modal/Modal";
import SimpleButton from "../../../../../global/SimpleButton/SimpleButton";
import { getAPI } from "../../../../../services/CRUDServices";
import { setOrder } from "../../../../../redux/OrderData/OrderData";
import CustomSelectNav from "../../../../../global/CustomSelectNav/CustomSelectNav";
import Nothing from "../../../../../assets/images/Nothing.png";
import { getUrls } from "../../../../../services/api.enums";
import useDebounce from "../../../../../tools/hooks/useDebounce";
import AutocompleteInput from "../../../../../global/Autocomplete/AutocompleteInput";
import CustomerElements from "../Elements/CustomerElements";
import EditCustomerPhone from "./EditCustomerPhone";
import Spinner from "../../../../../components/Spinner/Spinner";

interface SelectCustomerFormProps {
  open: boolean;
  setOpen: (value: boolean) => void;
}

const SelectCustomerForm = ({ open, setOpen }: SelectCustomerFormProps) => {
  const [Nav, setNav] = useState(2);
  const [Customer, setCustomer] = useState<any>();
  const [Customers, setCustomers] = useState([]);
  const [Edited, setEdited] = useState(false);
  const [Search, setSearch] = useState("");
  const [Loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const debouncedValue = useDebounce<string>(Search, 500);

  const handleGetCustomers = useCallback(() => {
    setLoading(true);
    getAPI(`${getUrls.customerSearch}${debouncedValue}&type=&prospect=0`).then(
      (res) => setCustomers(res.data.payload)
    );
    setLoading(false);
  }, [debouncedValue]);

  useEffect(() => {
    open && !Edited && handleGetCustomers();
  }, [Edited, handleGetCustomers, open]);

  useEffect(() => {
    open && setEdited(false);
  }, [open]);

  useEffect(() => {
    if (Search !== "" && debouncedValue !== "") {
      handleGetCustomers();
    }
  }, [Search, debouncedValue, handleGetCustomers]);

  const handleSelectCusotmer = () => {
    if (Customer.telephones.length === 0) {
      toast.error("ابتدا برای مشتری تلفن اضافه کنید");
    } else if (Customer.id) {
      dispatch(
        setOrder({
          senderCustomerId: Customer.id,
          senderCustomerName: Customer.name,
          senderPhoneId: Customer.telephones.at(-1).id,
          senderAddressId: undefined,
          senderAddressName: undefined,
          returnAddressId: undefined,
          returnAddressName: undefined,
          returnHubId: undefined,
          returnHubName: undefined,
          returnAddressTitle: undefined,
          returnAddressPostalCode: undefined,
          returnAddressDetail: undefined,
          returnLat: null,
          returnLng: null,
          returnHubAddress: undefined,
          pickupAddressId: undefined,
          pickupHubId: undefined,
          pickupHubName: undefined,
          withCod:Customer.withCod,
          withPostPaid:Customer.withPostPaid

        })
      );
      setOpen(false);
    } else {
      toast.error("ابتدا مشتری را انتخاب کنید");
    }
  };

  const NavOption = [
    {
      title: "جدید",
      active: 1,
      handleClick: () =>
        navigate("/basic-information/customer-management/true"),
    },
    { title: "انتخاب از لیست", active: 2, handleClick: () => setNav(2) },
  ];
  const handleEditCustomer = () => {
    setEdited(false);
    handleGetCustomers();
  };

  return (
    <Modal visible={open} setVisible={setOpen} title="فرستنده">
      <CustomSelectNav
        navOption={NavOption}
        nav={Nav}
        wrapperClassName="w-80"
      />
      {Edited ? (
        <EditCustomerPhone
          currentData={Customer}
          setCustomer={setCustomer}
          handleSuccess={handleEditCustomer}
        />
      ) : (
        <>
          <AutocompleteInput
            placeholder="جستجو"
            wrapperClassName="w-full mt-4"
            value={Search}
            onChange={(e) => setSearch(e.target.value)}
          />

          {Loading ? (
            <Spinner />
          ) : Customers.length > 0 ? (
            <>
              <div className="flex flex-col gap-3 max-h-[16.5rem] min-h-[16.5rem] overflow-auto">
                {Customers.map((item: any) => (
                  <CustomerElements
                    key={item.id}
                    item={item}
                    Customer={Customer}
                    setCustomer={setCustomer}
                    handleEdit={() => setEdited(true)}
                  />
                ))}
              </div>
              <div className="btnForm">
                <SimpleButton
                  handelClick={() => setOpen(false)}
                  text="لغو"
                  className="full-lightTomato-btn w-full"
                />
                <SimpleButton
                  handelClick={handleSelectCusotmer}
                  text="تایید"
                  className="full-tomato-btn w-full"
                />
              </div>
            </>
          ) : (
            <div className="my-6 max-h-80 min-h-[20rem]">
              <img src={Nothing} className="w-80" alt="Nothing" />
              <p className="text-center text-base text-darkBorder mb-5">
                در حال حاضر فرستنده ای در لیست وجود ندارد
              </p>
            </div>
          )}
        </>
      )}
    </Modal>
  );
};

export default SelectCustomerForm;
